// @flow

import React from 'react';
import type { Node } from 'react';
import { useLocation } from 'react-router-dom';
import Url from 'url-parse';
import { Heading, MediaQuery, VerticalMenu } from '@riseart/common';
import { normalizeUri } from 'shared_services/riseart/utils/RouteUtils';
import { VerticalMenuOverlay } from 'shared_components/common/menu/overlay/Menu';

import { raScreenMd } from '@riseart/antd-provider/dist/website/variables.less';
import {
  cmsSidemenuCls,
  cmsSidemenuBtnWrapperCls,
} from 'shared_components/cms/modules/sidemenu/Sidemenu.less';

type Props = {
  title?: string,
  menu?: Object,
};

/**
 * CmsModuleSidemenu
 *
 * @param {Props} props
 * @returns {Node}
 */
export const CmsModuleSidemenu = ({ title, menu }: Props): Node => {
  const { pathname } = useLocation();

  if (!menu) {
    return null;
  }

  const menuItems = menu.map(({ text, uri, external = false }) => ({
    key: text,
    label: text,
    url: uri,
    selected: uri && Url(normalizeUri(uri)).pathname === pathname,
    linkProps: { external },
  }));

  return (
    <div className={cmsSidemenuCls}>
      <MediaQuery minWidth={raScreenMd}>
        {(isScreenMd) =>
          isScreenMd ? (
            <React.Fragment>
              {title ? (
                <Heading tag="h3" level="2">
                  {title}
                </Heading>
              ) : null}

              <VerticalMenu disableFixedMenu items={menuItems} />
            </React.Fragment>
          ) : (
            <div className={cmsSidemenuBtnWrapperCls}>
              <VerticalMenuOverlay title={title} items={menuItems} />
            </div>
          )
        }
      </MediaQuery>
    </div>
  );
};
